import { FC } from "react";
import UpdateKVSDocumentsSvg from "../../public/icons/UpdateKVSDocuments.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const SyncGeometryIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><UpdateKVSDocumentsSvg/></span>;
